import { useState, useEffect } from 'react'

interface CountdownResult {
  days: number
  hours: number
  minutes: number
  seconds: number
  isExpired: boolean
  formattedTime: string
}

export function useCountdown(
  targetDate?: Date,
  durationInSeconds?: number,
): CountdownResult {
  const [timeLeft, setTimeLeft] = useState<number>(() => {
    if (targetDate) {
      return Math.max(
        0,
        Math.floor((targetDate.getTime() - new Date().getTime()) / 1000),
      )
    }
    if (durationInSeconds) {
      return durationInSeconds
    }
    return 900 // Default 15 mins
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 0) {
          clearInterval(interval)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const days = Math.floor(timeLeft / (3600 * 24))
  const hours = Math.floor((timeLeft % (3600 * 24)) / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60

  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

  return {
    days,
    hours,
    minutes,
    seconds,
    isExpired: timeLeft === 0,
    formattedTime,
  }
}
